export default __webpack_public_path__ + "static/media/Customer.bd5a0c4e.svg";